<template>
  <!--  <div class="speed-box" @click="changeSpeed">-->
  <!--    {{ speed }}X-->
  <!--  </div>-->
  <div class="right-box flex-row align-center justify-end">
    <img
      v-if="!props.pauseFlag && props.pauseShow"
      class="pause-icon cursor-pointer"
      src="@/assets/teacher_index/version5/progress_pause.svg"
      alt=""
      @click="emit('onPauseClass')"
    />
    <img
      v-if="!exerciseModal"
      :src="obj[speed]"
      alt=""
      class="speed-img"
      @click="changeSpeed(speed)"
    />
  </div>
</template>
<script setup lang="ts">
import mqttServer from "@/js/mqtt"
import { defineEmits, defineProps, onMounted, ref, defineExpose } from "vue"
import { useStorage } from "@vueuse/core"
import { getBrandImageUrl } from "@/js/brandImages"

const obj = {
  "1": getBrandImageUrl("speed/speed_1.svg"),
  "1.2": getBrandImageUrl("speed/speed_2.svg"),
  "1.5": getBrandImageUrl("speed/speed_3.svg"),
  "2": getBrandImageUrl("speed/speed_4.svg"),
}
const props = defineProps(["pauseFlag", "exerciseModal", "pauseShow"])
const emit = defineEmits(["onPauseClass", "changeEnd"])
const speedList = [1, 1.2, 1.5, 2]
const speed = useStorage("xf-speed", 1, localStorage)

const instructData = ref({
  project: "lxll",
  page: "teachIndex",
  module: "SpeedSwitch",
  userType: 1,
  data: null,
  fn: "",
  param: null,
  timestamp: " ",
})

onMounted(() => {
  mqttServer.onMqttMessage(instructData.value.module, onMessageReceived)
})

function onMessageReceived(msg: any) {
  console.log(msg, "11111111")
  if (msg.fn == "changeSpeed") {
    changeSpeedSync(msg.params[0])
  }
}

function changeSpeed(speed) {
  mqttServer
    .pushMsg(instructData.value, {
      params: [speed],
      fn: "changeSpeed",
      msgType: "function",
    })
    .then(() => {
      changeSpeedSync(speed)
    })
}

function changeSpeedSync(value?: any) {
  if (value) {
    console.log("value22", value)
    const index = speedList.indexOf(value)
    if (index !== 3 && index !== -1) {
      speed.value = speedList[index + 1]
    } else if (index === 3) {
      speed.value = speedList[0]
    }

    return
  }
  let currentIndex = speedList.indexOf(speed.value)
  currentIndex = ++currentIndex % speedList.length
  speed.value = speedList[currentIndex]
}

// 暴露方法
defineExpose({
  changeSpeedSync,
})
</script>

<style scoped lang="less">
.speed-box {
  border-radius: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.2rem 1rem;
  color: #2bca9c;
  font-size: 0.8rem;
}

.speed-img {
  width: 2rem;
}

.pause-icon {
  width: 2rem;
  margin-right: 1rem;
  position: relative;
  z-index: 99;
}
</style>
